import React, {useRef} from 'react';
import styled from "styled-components";
import {handleFormatNumbers} from "@helpers/numbers";
import ButtonTransparent from "@atoms/button.transparent";
import Icon from "@atoms/icon";
import {isEmpty} from "@helpers/helpers";
import CloseIcon from "@icons/close.svg";


function DropdownInput({type, searchable, handleSearch, selected_range, setItemsPosition, handleItems}) {
    const searchInputRef = useRef('');
    const searchClearRef = useRef('');

    const handleRangeInput = (e) => {
        let value = handleFormatNumbers(String(e.target.value));

        handleItems(value, false, false);
    };

    const handleSearchInput = (e) => {
        const pattern = String(e.target.value).toLowerCase();

        handleSearch(pattern);

        if (!isEmpty(searchClearRef) && !isEmpty(searchClearRef.current)) {
            if (pattern.length) {
                searchClearRef.current.classList.remove('d-none');
            } else {
                searchClearRef.current.classList.add('d-none');
            }
        }
    };

    const handleClearSearch = () => {
        if (!isEmpty(searchInputRef) && !isEmpty(searchInputRef.current)) {
            searchInputRef.current.value = '';
            handleSearch('');

            if (!isEmpty(searchClearRef) && !isEmpty(searchClearRef.current)) {
                searchClearRef.current.classList.add('d-none');
            }
        }
    };

    if (typeof type !== "undefined" && type === 'range') {
        return (
            <Range className="d-flex align-items-center">
                <input type="tel"
                       onChange={handleRangeInput}
                       value={(typeof selected_range.min !== "undefined" && selected_range.min !== '' && selected_range.min > 0 && selected_range.min !== '0') ? handleFormatNumbers(String(selected_range.min)) : ''}
                       defaultValue=""
                       className="form-control text-center"
                       placeholder="حداقل"
                       onFocus={() => setItemsPosition('right')}
                />
                <span className="mr-8 ml-8">تا</span>

                <input type="tel"
                       onChange={handleRangeInput}
                       value={(typeof selected_range.max !== "undefined" && selected_range.max !== '' && selected_range.max > 0 && selected_range.max !== '0') ? handleFormatNumbers(String(selected_range.max)) : ''}
                       defaultValue=""
                       className="form-control text-center"
                       placeholder="حداکثر"
                       onFocus={() => setItemsPosition('left')}
                />
            </Range>
        )
    } else if (typeof searchable !== "undefined" && searchable) {
        return (
            <Input className="position-relative">
                <input type="text" ref={searchInputRef} onChange={handleSearchInput} className="form-control selection-search" placeholder="جستجو"/>

                <ClearSearch onClick={handleClearSearch} buttonRef={searchClearRef} className="js-clear-search d-none align-items-center justify-content-center">
                    <Icon width={8} height={8}>
                        <CloseIcon/>
                    </Icon>
                </ClearSearch>
            </Input>
        )
    } else {
        return null;
    }
}

export default DropdownInput;

// styles

const ClearSearch = styled(ButtonTransparent)`
    display: flex;
    background-color: ${props => props.theme.gray200};
    width: 20px;
    height: 20px;
    position: absolute;
    top: 50%;
    left: 32px;
    outline: 0;
    line-height: 0;
    border: 0;
    border-radius: 50%;
    transform: translate(0, -50%);
`;

const Input = styled.div`
    height: 40px;
    padding: 0 24px;
    
    @media only screen and (min-width: ${props => props.theme.screenSmMax}) {
         margin-bottom: 16px;
    }
    
    
    @media only screen and (max-width: ${props => props.theme.screenXsMax}) {
        padding: 0 24px;
        margin-bottom: 16px;
    }
`;

const Range = styled.div`
    height: 40px;
    margin-bottom: 8px;
    padding: 0 24px;
    
    input {
        max-width: calc(50% - 13px);
        padding: 8px;
    }
`;